(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const drawer = document.querySelector('cart-drawer');
  const cartIcon = document.querySelector('#cart-icon-bubble');

  if (!drawer && !cartIcon) return;

  const replayClass = (element, className, duration = 450) => {
    if (!element || reducedMotion.matches) return;
    element.classList.remove(className);
    void element.offsetWidth;
    element.classList.add(className);
    window.setTimeout(() => element.classList.remove(className), duration);
  };

  const getCartCount = () => {
    const count = cartIcon?.querySelector('.cart-count-bubble [aria-hidden="true"]');
    return count ? count.textContent.trim() : '0';
  };

  let lastCartCount = getCartCount();

  if (cartIcon) {
    const cartIconObserver = new MutationObserver(() => {
      const nextCount = getCartCount();
      if (nextCount === lastCartCount) return;
      lastCartCount = nextCount;
      replayClass(cartIcon, 'kxng-cart-pulse', 420);
      replayClass(cartIcon.querySelector('.cart-count-bubble'), 'kxng-count-pop', 400);
    });

    cartIconObserver.observe(cartIcon, { childList: true, subtree: true, characterData: true });
  }

  if (!drawer) return;

  let itemQuantities = new Map();
  let lastTotal = '';
  let shippingUnlocked = false;
  let reconcileTimer = null;

  const getItemKey = (row) => {
    const productLink = row.querySelector('.cart-item__name');
    return productLink?.getAttribute('href') || row.id;
  };

  const getQuantity = (row) => {
    const input = row.querySelector('.quantity__input');
    return input ? String(input.value) : '';
  };

  const reconcileDrawer = (animateChanges = true) => {
    const nextQuantities = new Map();
    const rows = drawer.querySelectorAll('.cart-item');

    rows.forEach((row) => {
      const key = getItemKey(row);
      const quantity = getQuantity(row);
      nextQuantities.set(key, quantity);

      if (animateChanges && drawer.classList.contains('active')) {
        if (!itemQuantities.has(key)) {
          replayClass(row, 'kxng-cart-item-enter', 420);
        } else if (itemQuantities.get(key) !== quantity) {
          replayClass(row.querySelector('.quantity__input'), 'kxng-qty-pop', 360);
        }
      }
    });

    itemQuantities = nextQuantities;

    const total = drawer.querySelector('.totals__total-value');
    const nextTotal = total ? total.textContent.trim() : '';
    if (animateChanges && lastTotal && nextTotal && nextTotal !== lastTotal && drawer.classList.contains('active')) {
      replayClass(total, 'kxng-total-pop', 380);
    }
    lastTotal = nextTotal;

    const progress = drawer.querySelector('.kxng-shipping-progress__track');
    const progressValue = progress ? Number.parseInt(progress.getAttribute('aria-valuenow') || '0', 10) : 0;
    const nextUnlocked = progressValue >= 100;

    if (animateChanges && nextUnlocked && !shippingUnlocked && drawer.classList.contains('active')) {
      replayClass(progress, 'kxng-shipping-unlocked', 980);
    }
    shippingUnlocked = nextUnlocked;
  };

  reconcileDrawer(false);

  const drawerObserver = new MutationObserver(() => {
    window.clearTimeout(reconcileTimer);
    reconcileTimer = window.setTimeout(() => reconcileDrawer(true), 30);
  });

  const drawerPanel = drawer.querySelector('#CartDrawer') || drawer;
  drawerObserver.observe(drawerPanel, { childList: true, subtree: true, characterData: true });

  const classObserver = new MutationObserver(() => {
    if (!drawer.classList.contains('active')) return;
    window.setTimeout(() => reconcileDrawer(true), 40);
  });

  classObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });

  drawer.addEventListener('click', (event) => {
    const removeButton = event.target.closest('cart-remove-button');
    if (!removeButton) return;

    const row = removeButton.closest('.cart-item');
    if (!row || reducedMotion.matches) return;

    row.classList.add('kxng-cart-item-removing');
    window.setTimeout(() => {
      if (row.isConnected) row.classList.remove('kxng-cart-item-removing');
    }, 900);
  });
})();
